// extracted by mini-css-extract-plugin
module.exports = {"root":"BannerAd_root__EMJWu"};